import { FC } from 'react';
import './gauge.scss';

/* -------------------------------------------------------------------------------- *\
|                               GaugeProps
\* -------------------------------------------------------------------------------- */
interface GaugeProps
{
	percent: number,
    timefromstart: string,
	children?: Node,
}
/* -------------------------------------------------------------------------------- *\
|                               Gauge
\* -------------------------------------------------------------------------------- */
export const Gauge : FC<GaugeProps> = ({percent, timefromstart}) =>
{
    var v:number = percent ? percent : 0;
    if (v < 0) v = 0;
    if (v > 100) v = 100;
    return (
        <div className='gauge'>
            <div className="gauge__container">
                <div className="gauge__bar" style={{ width: `${v}%` }}></div>
            </div>
            {
                    timefromstart === "" ? <p className='gauge__value'>{v.toFixed() + "%"}</p> : <div className='progress__value__text'>Start in : {timefromstart}</div>
            }
        </div>
    );
}
